module.exports = __webpack_public_path__ + "img/header.fa295725.jpg";